import { userIsNonCustomer } from '@/helpers/customerUtils';
import { Customer } from '@/types/Customer';
import { useQuery } from '@tanstack/react-query';
import { getDevices } from '../data/HeatExchangeControl';

const useHeatExchangeDevices = (selectedCustomer: Customer) => {
  const { data: availableDevices, isLoading: isLoadingAvailableDevices } =
    useQuery({
      queryKey: ['FJVHDevices', selectedCustomer?.customerId],
      queryFn: () =>
        getDevices(selectedCustomer?.customerId).then((devices) => {
          return devices.data.data[0].items || [];
        }),
      enabled: !!selectedCustomer?.customerId && !userIsNonCustomer(selectedCustomer),
    });

  return { availableDevices, isLoadingAvailableDevices };
};

export default useHeatExchangeDevices;
